var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.fetchLoading)?_c('DataLoader',{attrs:{"loading":_vm.fetchLoading}}):_c('Form',{attrs:{"exhibit":_vm.exhibit},on:{"exhibit-action":_vm.updateExhibit}})}
var staticRenderFns = []

export { render, staticRenderFns }